import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NotificationItem} from '../notification.model';
import {MatDialog} from '@angular/material/dialog';
import {NotificationDialogComponent} from '../notification-dialog/notification-dialog.component';
import {HttpService} from '../../../core';
import {NotificationService} from '../../../core/services/notification.service';

@Component({
    selector: 'app-notification-item',
    templateUrl: 'notification-item.component.html',
    styleUrls: ['notification-item.component.scss']
})
export class NotificationItemComponent {
    @Input() notificationItem: NotificationItem;
    @Output() reduceUnreadCount = new EventEmitter<Event>();

    constructor(private dialog: MatDialog, private httpService: HttpService, public notificationService: NotificationService) {
    }

    // 查看消息细节
    openDetailDialog() {
        this.dialog.open(NotificationDialogComponent, {
            width: '80%',
            data: this.notificationItem
        });
    }

    // 把消息标为已读
    markAsRead($event) {
        if (this.notificationService.getCurrentReceiver(this.notificationItem.notificationReceivers)?.status !== 1) {
            this.httpService.putNotificationStatusByAuth(this.notificationItem.id).toPromise().then((res) => {
                console.log(res);
            });
            this.notificationService.getCurrentReceiver(this.notificationItem.notificationReceivers).status = 1;
            this.reduceUnreadCount.emit();
        }
    }
}
